export const NOKEY_WEB_ENV = "NOKEY_ENV";
export const NOKEY_WEB_FUNC_RED_LIST = "NOKEY_WEB_FUNC_RED_LIST";
export const NOKEY_WEB_HELP_CENTER = "NOKEY_WEB_HELP_CENTER";
